
import React from 'react'
import { IconButton2Styles } from './Styled'

const CustomIconButton = (props) => {
    const { children } = props;

    return (
        <IconButton2Styles {...props}>
            {children}
        </IconButton2Styles>
    )
}

export default CustomIconButton